export const adminCopy = {
  heading: "Admin dashboard",
  body: "Manage the small pilot group and keep setup activity visible.",
  refresh: "Refresh",
  downloadStats: "Download stats (.xlsx)",
  downloadStatsFailure: "Could not download stats",
  usersHeading: "Users",
  usersListTab: "All users",
  usersCreateTab: "Create user",
  createUserHeading: "Create user",
  username: "Username",
  role: "Role",
  userRole: "User",
  adminRole: "Admin",
  create: "Create",
  searchShellHeading: "Search shell",
  openSearch: "Open search view",
  searchShellBody: "Clause data is intentionally not imported in this milestone.",
  tuningHeading: "Search terms",
  generalTerms: "General terms",
  clauseTerms: "Clause terms",
  phrase: "Search phrase",
  expansion: "Expansion",
  clauseNumber: "Clause number",
  pin: "Pin as top result",
  addGeneral: "Add general term",
  addClause: "Add clause term",
  usage: "Usage",
  type: "Type",
  zeroResults: "Zero-result searches",
  noZeroResults: "No zero-result searches yet.",
  deleteRule: "Delete",
  confirmDeleteRule: "Delete this search term?",
  confirmDeleteRuleAction: "Confirm delete",
  notUsedYet: "Not used yet",
  usedTimes: "Used {count} times",
  pinned: "pinned",
  loadTuningFailure: "Could not load search terms",
  createTuningFailure: "Could not add search term",
  deleteTuningFailure: "Could not delete search term",
  readsHeading: "Jim's reads",
  reviewQueue: "Review queue",
  awaitingApproval: "Awaiting approval",
  approvedReads: "Approved",
  noDraftReads: "No reads are awaiting approval.",
  noApprovedReads: "No approved reads yet.",
  needsRead: "Needs a read",
  noReadSuggestions: "No clause suggestions yet.",
  searchHits: "{count} search hits",
  useSuggestion: "Use clause",
  createReadHeading: "Create a read",
  readBody: "Plain-language read",
  createRead: "Save draft",
  editRead: "Edit",
  saveRead: "Save",
  approveRead: "Approve",
  deleteRead: "Delete",
  confirmApproveRead: "Approve this read for users?",
  confirmApproveReadAction: "Confirm approve",
  confirmDeleteRead: "Delete this read immediately?",
  confirmDeleteReadAction: "Confirm delete",
  editApprovedWarning: "Saving changes takes this approved read offline until it is approved again.",
  reviewedBy: "Reviewed by",
  unknownReviewer: "unknown reviewer",
  draftUpdated: "Draft updated",
  loadReadsFailure: "Could not load Jim's reads",
  createReadFailure: "Could not create Jim's read",
  updateReadFailure: "Could not update Jim's read",
  approveReadFailure: "Could not approve Jim's read",
  deleteReadFailure: "Could not delete Jim's read",
  reportsHeading: "Content reports",
  reportsAll: "All",
  reportsNew: "New",
  reportsTriaged: "Triaged",
  reportsFixed: "Fixed",
  reportsWontfix: "Won't fix",
  noReports: "No reports match this status.",
  reportBy: "Reported by",
  reportReviewedBy: "Reviewed by",
  reportNoNote: "No reader note supplied.",
  reportAdminNote: "Admin note",
  reportAdminNotePlaceholder: "Optional note for the review queue",
  reportMarkTriaged: "Mark triaged",
  reportMarkFixed: "Mark fixed",
  reportMarkWontfix: "Won't fix",
  reportPreviousPage: "Previous",
  reportNextPage: "Next",
  reportPage: "Page {page} of {total}",
  loadReportsFailure: "Could not load content reports",
  updateReportFailure: "Could not update the report",
  reportIssueTypeLabels: {
    text_jumbled: "Text is jumbled or run together",
    text_missing: "Text is missing",
    image_wrong: "Wrong or missing figure/table image",
    image_cropped: "Image is cropped wrongly",
    wrong_reference: "Wrong page number or clause number",
    bad_link: "A cross-reference link is wrong or missing",
    jim_read_wrong: "Jim's read is wrong or misleading"
  },
  table: {
    username: "Username",
    email: "Email",
    role: "Role",
    status: "Status",
    licensedAccess: "Licensed access",
    created: "Created",
    actions: "Actions",
    passwordChangeRequired: "Password change required",
    locked: "Locked",
    active: "Active",
    disabled: "Disabled",
    resetPassword: "Reset password",
    confirmResetPassword: "Reset this user's password?",
    confirmReset: "Confirm reset",
    disable: "Disable",
    confirmDisable: "Disable this user? They will not be able to sign in.",
    confirmDisableAction: "Confirm disable",
    enable: "Enable",
    delete: "Delete",
    confirmDelete: "Confirm delete",
    confirmDeletePrompt: "Confirm delete?",
    cancel: "Cancel",
    disabledRole: "Previous role"
  },
  disabledSuffix: "disabled",
  loadUsersFailure: "Could not load users",
  createUserFailure: "User creation failed",
  resetPasswordFailure: "Password reset failed",
  disableUserFailure: "Disable user failed",
  enableUserFailure: "Enable user failed",
  licensedAccessFailure: "Licensed access update failed",
  deleteUserFailure: "User deletion failed",
  console: {
    usersTab: "Users",
    termsTab: "Search terms",
    readsTab: "Jim's reads",
    reportsTab: "Reports",
    settingsTab: "My settings",
    passwordTab: "Change password",
    emailTab: "Change email"
  },
  settingsForm: {
    currentPasswordLabel: "Current password",
    newPasswordLabel: "New password",
    confirmPasswordLabel: "Confirm new password",
    newEmailLabel: "New email",
    confirmEmailLabel: "Confirm new email",
    changePasswordAction: "Change password",
    changeEmailAction: "Change email",
    passwordsMismatch: "New passwords do not match",
    emailsMismatch: "Email addresses do not match",
    passwordChanged: "Password changed",
    emailChanged: "Email changed to {email}",
    passwordFailure: "Could not change password",
    emailFailure: "Could not change email"
  },
  explainers: {
    users: "Manage pilot access and account status.",
    createUser: "Create an account for a pilot user and share their temporary credentials securely.",
    generalTerms: "Add and review aliases that make common search language easier to find.",
    clauseTerms: "Map search phrases to a specific clause or preferred result.",
    zeroResults: "Review searches that returned no matching clauses.",
    createRead: "Draft a plain-language read for a clause.",
    reviewQueue: "Review draft reads before making them available to users.",
    reports: "Review problems readers found in clause, figure and table records.",
    needsRead: "Start a read for clauses that users search for most.",
    password: "Update your password using your current password to confirm the change.",
    email: "Update the email address used for account recovery."
  }
} as const;
